// extracted by mini-css-extract-plugin
module.exports = {"CalendarItem":"CalendarItem_CalendarItem__3gnIw","primary":"CalendarItem_primary__CuX1t","background":"CalendarItem_background__1EU3q","content":"CalendarItem_content__2AF80"};